import {
  type RemixiconComponentType,
  RiBookmarkLine,
  RiCheckboxCircleLine,
  RiErrorWarningLine,
  RiFireLine,
  RiFlag2Line,
  RiGroupLine,
  RiHeartLine,
  RiInformationLine,
  RiLightbulbLine,
  RiPriceTag3Line,
  RiRocketLine,
  RiShieldStarLine,
  RiSparklingLine,
  RiStarLine,
  RiThumbUpLine,
  RiTrophyLine,
} from '@remixicon/react';

export const TAG_ICON_COMPONENTS = {
  RiPriceTag3Line,
  RiStarLine,
  RiHeartLine,
  RiBookmarkLine,
  RiFlag2Line,
  RiLightbulbLine,
  RiFireLine,
  RiThumbUpLine,
  RiCheckboxCircleLine,
  RiErrorWarningLine,
  RiInformationLine,
  RiSparklingLine,
  RiRocketLine,
  RiTrophyLine,
  RiGroupLine,
  RiShieldStarLine,
} satisfies Record<string, RemixiconComponentType>;

export type TagIconName = keyof typeof TAG_ICON_COMPONENTS;

export const TAG_ICONS = Object.keys(
  TAG_ICON_COMPONENTS,
) as readonly TagIconName[];

export const DEFAULT_TAG_ICON: TagIconName = 'RiPriceTag3Line';
